<template>
  <section class="hero hero-main is-fullheight">
    <nav class="navbar is-transparent" role="navigation" aria-label="dropdown navigation">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
          <img src="@/assets/logo-cpe-2.png" alt width="auto" height="auto" />
        </router-link>
      </div>
    </nav>
  <v-app>
    <div class="hero-body">
      <transition name="fade" mode="out-in">
      
          <router-view></router-view>
       
      </transition>
    </div>
 </v-app>
    <div class="contLogoMintic">
      <div class="contenido1">
        <img src="@/assets/logo-mintic.png" alt width="auto" height="auto" />
      </div>
    </div>
  </section>
</template>

<script>
import OverlayLoading from "./components/OverlayLoading";
import { mapGetters } from "vuex";
export default {
  name: "app",
  components: { OverlayLoading },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss">
html,
body {
  font-family: "Arial", serif;
  font-size: 14px;
  font-weight: 300;
  overflow: auto;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.hero.hero-main {
  background: #ffffff;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
  top: 0px;
  left: 0px;
  margin: 0px;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}
.contLogoMintic {
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  text-align: center;
}
.contenido1 {
  max-width: 250px;
  max-height: 250px;
  display: inline-block;
}
</style>
